import { NetworkStatus } from '@cbridge-utils/network';
import { IPriceFilteringRuleStore } from './priceFilteringRule.interface';

export const priceFilteringRuleInitialState: IPriceFilteringRuleStore = {
  list: [],
  networkStatus: NetworkStatus.None,
};
